import __request__ from "routing/request";
export function validateQuery(validationRequest) {
  return __request__("POST", "/search/validate", validationRequest, {}, {
    "Accept": ["application/json"]
  });
}
